import React from "react";
import {
    useLocation
} from "react-router-dom";
import logo from "../../source/image/ih_logo.png";
import {GrayLog} from "../../grayLog/grayLog";
import {LogEventName} from "../../grayLog/logKey";

const parseParamsFromPath = (path) => {
    let appRequest = {};
    if (path.includes("?")) {
        let str = path.substr(1);
        let params = str.split("&");
        for (let i = 0; i < params.length; i++) {
            let param = params[i];
            let kvs = param.split("=");
            appRequest[kvs[0]] = unescape(kvs[1]);
        }
    }
    return appRequest
}

const OpenApp = () => {
    const {search} = useLocation(); //获取url中"?"符后的字串

    const params = parseParamsFromPath(search)
    const triggerSource = params["src"] || "0"

    window.onload = () => {
        const isWechat = is_weiXin();
        !isWechat && openApp();
        GrayLog.event(LogEventName.openAppPage, {isWechat: isWechat, triggerSource: triggerSource});
    };

    // 当前页面失去焦点，清除延时任务，不提示用户下载
    window.onblur = () => {
        window.mTimer && clearTimeout(window.mTimer);
        window.mTimer = undefined;
    };

    const writeClipboard = async (text) => {
        try {
            await navigator.clipboard.writeText(text);
            // alert(`Write to clipboard ${text}`);
        } catch (err) {
            console.error('Failed to write to clipboard: ', err);
            // alert('Failed to write to clipboard');
        }
    }

    const generateAppRequestUrl = (needCategory) => {
        let category = "";
        let content = "";

        if (params["ac"]) {
            category = "accesscode";
            content = params["ac"];
        } else if (params["dr"]) {
            category = "doctorinfo";
            content = params["dr"];
        } else if (params["rg"]) {
            category = "register";
            content = params["rg"];
        }

        if (needCategory && category.length === 0) {
            return '';
        } else {
            return 'viphealth://auth/router?category='+category+'&content='+content;
        }
    }

    const generateAppRequestScheme = () => {
        let appRequestUrl = generateAppRequestUrl(true);

        if (!appRequestUrl) { return ''; }

        let time = (new Date()).getTime();
        return JSON.stringify({
            url: appRequestUrl,
            time: time
        });
    }

    const isAndroid = () => {
        let u = navigator.userAgent;
        return u.indexOf('Android') > -1 || u.indexOf('Linux') > -1;
    }

    const isIOS = () => {
        return !!navigator.userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
    }

    const is_weiXin = () => {
        let ua = navigator.userAgent.toLowerCase();
        return !!ua.match(/MicroMessenger/i);
    }

    // const isPC = () => {
    //     let userAgentInfo = navigator.userAgent;
    //     let Agents = ["Android", "iPhone",
    //         "SymbianOS", "Windows Phone",
    //         "iPad", "iPod"];
    //     let flag = true;
    //     for (let v = 0; v < Agents.length; v++) {
    //         if (userAgentInfo.indexOf(Agents[v]) > 0) {
    //             flag = false;
    //             break;
    //         }
    //     }
    //     return flag;
    // }

    const openApp = (redirectToStore) => {
        if (isIOS() || isAndroid()) {
            window.location.href = generateAppRequestUrl(false);
            GrayLog.event(LogEventName.openApp, {triggerSource: triggerSource})
        }

        if (redirectToStore) {
            window.mTimer = setTimeout(() => {
                downloadApp();
            }, 4000);
        }
    }

    const downloadApp = () => {
        let content = generateAppRequestScheme();
        content && writeClipboard(content);

        if (isAndroid()) {
            window.location.href = 'https://play.google.com/store/apps/details?id=com.react_viphealth';
        } else if (isIOS()) {
            window.location.href = 'https://apps.apple.com/us/app/iclinichealth/id1265405734'; //'https://itunes.apple.com/us/app/viphealth/id1265405734?mt=8';
        } else {

        }

        GrayLog.event(LogEventName.downloadApp, {triggerSource: triggerSource})
    }

    const renderBrowserContent = () => {
        return (
            <div className={"w-full max-w-screen-sm flex flex-col items-center"}>
                <div className={"w-full flex flex-row items-center justify-center"}>
                    <img className={"w-12"} src={logo} alt={""}/>
                    <p className={"text-3xl ml-4"}><span className={"font-semibold text-primary"}>iClinic</span>Health</p>
                </div>
                <div className={"w-full flex flex-col items-center mt-8"}>
                    <p className={"text-3xl text-primary font-bold"}>Health Management</p>
                    <p className={"text-3xl text-primary font-bold mt-2"}>Made Simple</p>
                </div>
                <div className={"w-full flex flex-col py-12 px-8"}>
                    <div className={"w-full flex flex-col items-center"}>
                        <p className={"text-lg"}>Already have our app?</p>
                        <button onClick={() => {
                            openApp(true)
                        }} className={'w-full bg-primary py-2 mt-2 rounded-3xl max-w-xs'}>
                            <div className={'text-white text-lg font-semibold'}>{"Open App"}</div>
                        </button>
                    </div>
                    <div className={"w-full flex flex-col items-center mt-8"}>
                        <p className={"text-lg"}>Don't have the app yet?</p>
                        <button onClick={downloadApp} className={'w-full bg-primary py-2 mt-2 rounded-3xl max-w-xs'}>
                            <div className={'text-white text-lg font-semibold'}>{"Download for Free"}</div>
                        </button>
                    </div>
                </div>
            </div>
        )
    }

    const renderWechatContent = () => {
        return (
            <div className={"w-full max-w-screen-sm flex flex-col items-center"}>
                <p className={"text-2xl font-bold text-center"}>{"To view this website, please copy and open link in your browser."}</p>
                <p className={"text-2xl font-bold text-center mt-2"}>{"如需浏览，请长按网址复制后使用浏览器访问。"}</p>

                <div className={"max-w-full mt-8 p-2 bg-lightGray overflow-hidden"}>
                    <p className={"text-lg text-center break-words"}>{window.location.href}</p>
                </div>
            </div>
        )
    }

    return (
        <div className={"w-full px-5 py-32 flex flex-col items-center bg-white"}>
            {is_weiXin() ? renderWechatContent() : renderBrowserContent()}
        </div>
    )
}

export default OpenApp
